import { normalizeString } from './strings';
import { IntlShape } from 'react-intl';
import orderBy from 'lodash/orderBy';

export type SearchValue = string | null | undefined;

type NamedItem = {
    name?: string | null;
};

export const buildSearchValues = (values: SearchValue[]): string[] => (
    values
        .map(value => normalizeString(value))
        .filter(Boolean)
);

export const getNamesListValue = (items: NamedItem[]): string => (
    normalizeString(items.map(item => item.name ?? '').join(' '))
);

export const getSortedNamesListValue = (items: NamedItem[]): string => (
    normalizeString(
        orderBy(items, item => (item.name ?? '').toLowerCase(), 'asc')
            .map(item => item.name ?? '')
            .join(' ')
    )
);

export const getStatusMessageId = (isActive: boolean) => (isActive ? 'active' : 'suspended');

export const getStatusValue = (intl: IntlShape, isActive: boolean): string => (
    intl.formatMessage({ id: getStatusMessageId(isActive) })
);

export const getStatusSortValue = (isActive: boolean): number => (isActive ? 0 : 1);

export const filterByStatusAndSearch = <T>(
    items: T[],
    selectedStatus: number,
    isActive: (item: T) => boolean,
    search: string,
    getSearchValues: (item: T) => string[],
): T[] => {
    let result = items;

    if (selectedStatus !== -1) {
        const isActiveValue = selectedStatus === 0;
        result = result.filter(item => isActive(item) === isActiveValue);
    }

    const normalizedSearch = normalizeString(search);
    if (!normalizedSearch) {
        return result;
    }

    return result.filter(item =>
        getSearchValues(item).some(value => value.includes(normalizedSearch))
    );
};
